import { getStorage, setStorage } from '@/libs/utils';
import { cdnLink } from '@/config';
import { newGameList, giftDetail } from '@/api/activity';
import { remindApi, raidersApi, raidersDetailApi, homeApi, giftApi, getBoxBanner, cloudDeviceApi, cloudProductApi, voucherApi } from '@/api/suspend';
import _ from 'lodash';
import { tencentCloudSetDevices } from '@/bridge/AppJsBridge';
import { buryReportV2 } from '@/libs/business/account';

const state = {
  summaryVisible: false,
  sideBarVisible: true,
  officialWechatVisible: false,
  portraitArticleVisible: false,
  account_name: '', // 公众号
  account_id: '', // 公众号id
  role: {},
  tabs: [
    {
      name: '首页',
      icon: `${cdnLink}/suspend/tongyong/shouye1.png`,
      activeIcon: `${cdnLink}/suspend/tongyong/shouye.png`,
      type: 'home',
      show: false,
    },
    {
      name: '首页',
      icon: `${cdnLink}/suspend/tongyong/shouye1.png`,
      activeIcon: `${cdnLink}/suspend/tongyong/shouye.png`,
      type: 'active',
      show: false,
    },
    {
      name: '个人',
      icon: `${cdnLink}/suspend/tongyong/geren1.png`,
      activeIcon: `${cdnLink}/suspend/tongyong/geren.png`,
      type: 'geren',
      show: true,
    },
    {
      name: '福利',
      icon: `${cdnLink}/suspend/tongyong/fuli1.png`,
      activeIcon: `${cdnLink}/suspend/tongyong/fuli.png`,
      type: 'welfare',
      show: false,
    },
    // {
    //   name: '云挂机',
    //   icon: `${cdnLink}/suspend/tongyong/qingbao1.png`,
    //   activeIcon: `${cdnLink}/suspend/tongyong/qingbao.png`,
    //   type: 'hangup',
    //   show: false,
    //   hint: false,
    // },
    {
      name: '情报',
      icon: `${cdnLink}/suspend/tongyong/qingbao1.png`,
      activeIcon: `${cdnLink}/suspend/tongyong/qingbao.png`,
      type: 'messages',
      show: false,
      hint: false,
    },
    {
      name: '攻略',
      icon: `${cdnLink}/suspend/tongyong/gonglue1.png`,
      activeIcon: `${cdnLink}/suspend/tongyong/gonglue.png`,
      type: 'raiders',
      show: false,
    },
    {
      name: '新游',
      icon: `${cdnLink}/suspend/tongyong/xinyou.png`,
      activeIcon: `${cdnLink}/suspend/tongyong/xinyou1.png`,
      type: 'newGame',
      show: false,
    },
    {
      name: '客服',
      icon: `${cdnLink}/suspend/tongyong/kefu1.png`,
      activeIcon: `${cdnLink}/suspend/tongyong/kefu.png`,
      type: 'kefu',
      show: true,
    },
    {
      name: '公众号',
      icon: `${cdnLink}/suspend/tongyong/wechat.png`,
      activeIcon: `${cdnLink}/suspend/tongyong/wechat.png`,
      type: 'officialWechat',
      show: false,
    },
  ],
  activeTab: {},
  remind: {},
  raidersList: [], // 攻略列表
  messagesList: [], // 情报列表
  benefit_list: [], // 福利tab列表
  banner_list: [], // 首页banner列表
  article_list: [], // 首页文章列表
  jump_mode: 0, // 跳转方式
  redirectArticle: null, // 首页和强提醒跳转文章时用到
  active_article: {}, // 攻略/情报 竖版界面选择某个攻略/情报后，进行存储
  active_menu: {}, // 攻略/情报 竖版界面选择某个攻略/情报后，进行存储
  active_menu_type: '', // 竖版界面展示文章后，当前文章类型(攻略/情报)
  strongRemindFlag: false, // 是否展示过强提醒弹窗
  newGameList: [], // 新游列表
  weakRemindList: [], // 剩余弱提醒未点击列表
  bindGift: '',
  personalAdSeat: [], // 个人中心顶部广告位列表
  personalAdBanner: [], // 个人中心顶部banner列表
  boxDownLoadShow: false,
  normal_gift: [],
  game_gift: [],
  giftRemindShow: false,
  giftCode: '',
  cloudChargeVisible: false, // 是否显示云手机支付界面
  cloud_hang_up_image: '',
  cloud_hang_up_box_url: '',
  cloud_hang_up_template_id: '',
  cloud_hang_up_template_name: '',
  bindPhoneVisible: false,
  bindHintText: '',
  cloudDeviceList: [],
  cloudProductList: [],
  voucherList: []
};

const mutations = {
  CHANGE_STATE: (state, obj) => {
    state = Object.assign(state, obj);
  },
  /**
   * @description 修改tabs
   * @param {action} . unshift push del
   */
  SET_TAB: (state, { action, val }) => {
    const tabIndex = state.tabs.findIndex((item) => item.type === val);
    switch (action) {
      case 'unshift':
        state.tabs.unshift(val);
        break;
      case 'push':
        state.tabs.push(val);
        break;
      case 'del':
        // del时val为需要删除的tab值
        state.tabs = state.tabs.splice(tabIndex, 1);
        break;
      case 'show':
        state.tabs[tabIndex].show = true;
        break;
      case 'hide':
        state.tabs[tabIndex].show = false;
        break;
      default:
        break;
    }
  },
  /**
   * @description 处理情报中心红点提示缓存逻辑
   * 处理后的情报列表(消息中心)数据结构
   * messages: [{
   *   jump_mode: 1, 跳转方式
   *   name: "", 菜单名称
   *   menu_id: "", 菜单id
   *   hint: true, 是否显示红点
   *   article_list: [ 文章列表
   *     {
   *       article_id: ''，文章id
   *       hint: true,
   *       name: ''
   *     }
   *   ]
   * }]
   * 缓存红点数据结构
   * messagesCache: {
   *   1(menu_id): {
   *     hint: true, // 请求文章后判断是否所有文章都点过，都点过置为false
   *     artList: [] // 已经点过的文章列表
   *   }
   * }
   * @param {messagesList} 已经处理过的情报列表 已经请求到的菜单下的文章列表会放到对应menu下的article_list，每次处理后调用该方法处理红点信息
   */
  SET_MESSAGES_REMIND: (state, messagesList) => {
    let messagesCache = getStorage('messages_hint_list') || {};
    const userName = getStorage('username');
    messagesCache = messagesCache[userName];
    const messages = _.cloneDeep(messagesList);
    let tabHintFlag = false; // 是否显示悬浮窗tabs上的红点
    if (!messagesCache && messages) {
      // 缓存中没有任何已经点掉的红点记录情况
      messages.map((menu) => {
        const { article_list } = menu;
        if (article_list && article_list.length) {
          article_list.map((article) => {
            article.hint = true;
          });
        }
        menu.hint = true;
        tabHintFlag = true;
      });
    } else {
      messages.map((menu) => {
        const { menu_id, article_list } = menu;

        if (!messagesCache[menu_id]) {
          // 缓存列表下无当前菜单id，当前菜单显示红点
          menu.hint = true;
          tabHintFlag = true;
        }

        if (article_list && article_list.length) {
          article_list.map((article) => {
            if (!messagesCache[menu_id]) {
              // 缓存列表中无当前菜单id，那么当前菜单下的文章全部显示红点
              article.hint = true;
            } else {
              // 缓存列表中有当前菜单id，那么当前菜单下文章在缓存列表中的不显示红点
              article.hint = !messagesCache[menu_id].artList.includes(article.article_id);
              if (article.hint) {
                // 只要有一篇文章不在缓存列表，分类和tab显示红点
                menu.hint = true;
                tabHintFlag = true;
              }
            }
          });
        }
      });
    }
    state.messagesList = messages;
    const tabs = _.cloneDeep(state.tabs);
    const tab = tabs.find((item) => item.type === 'messages');
    tab.hint = tabHintFlag;
    state.tabs = tabs;
  },
  /** 设置消息中心红点缓存, 并改变state中红点状态 */
  SET_MESSAGES_CACHE: (state, { menu_id, article_id }) => {
    const menu = state.messagesList.find((item) => item.menu_id == menu_id);
    const article_list = menu.article_list || [];
    const article = article_list.find((item) => item.article_id == article_id);
    if (!article) {
      menu.hint = false;
    } else {
      // 去掉当前文章的红点
      article.hint = false;
      // 若所有文章列表无红点，去掉分类红点
      const hintArt = article_list.filter((item) => item.hint);
      if (!hintArt.length) menu.hint = false;
    }
    // 如果所有分类无红点，去掉菜单栏中情报的红点
    const hintMenu = state.messagesList.filter((item) => item.hint);
    if (!hintMenu.length) {
      const tab = state.tabs.find((item) => item.type === 'messages');
      tab.hint = false;
    }

    const messagesCacheAll = getStorage('messages_hint_list') || {};
    const userName = getStorage('username');
    const messagesCache = messagesCacheAll[userName] || {};
    if (!messagesCache[menu_id]) {
      // 缓存中没有当前菜单 增加当前菜单，当前文章的缓存
      messagesCache[menu_id] = {
        hint: article_list.length > 1,
        artList: article_id ? [article_id] : [],
      };
    } else if (article_id) {
      let artCacheList = messagesCache[menu_id].artList;
      const articleList = article_list.map((art) => art.article_id);
      // 将缓存中的文章id过滤掉已经不在当前配置文章列表中存在的文章
      artCacheList = artCacheList.filter((artCacheId) => articleList.includes(artCacheId));
      const artList = new Set(artCacheList);
      artList.add(article_id);

      messagesCache[menu_id] = {
        hint: artList.size < article_list.length,
        artList: [...artList],
      };
    }
    messagesCacheAll[userName] = messagesCache;
    setStorage('messages_hint_list', messagesCacheAll);

    if (article_id) {
      const weakRemindListCopy = _.cloneDeep(state.weakRemindList);
      _.pull(weakRemindListCopy, article_id);
      state.weakRemindList = weakRemindListCopy;
    }
  },
  /**
   * 给某个菜单添加红点
   * @param {tabType} tab的type
   * @param {hintType} 提示类型 false.隐藏红点 true.显示红点
   */
  SET_TAB_HINT(state, { tabType, hintType }) {
    const tabs = _.cloneDeep(state.tabs);
    const tab = tabs.find((item) => item.type === tabType);
    tab.hint = hintType;
    state.tabs = tabs;
  },
  SET_RAIDERS_MENU(state, { menu_id, article_list, jump_mode }) {
    const raidersList = _.cloneDeep(state.raidersList);
    const menu = raidersList.find((item) => item.menu_id === menu_id);
    menu.article_list = article_list;
    menu.jump_mode = jump_mode;
    state.raidersList = raidersList;
  },
  // 处理h5弱提醒文章列表
  SET_WEAK_REMIND(state, messageList) {
    const messageListCopy = _.cloneDeep(messageList);
    let messagesCache = getStorage('messages_hint_list') || {};
    const userName = getStorage('username');
    messagesCache = messagesCache[userName] || {};
    const keys = Object.keys(messagesCache);
    let arr = [];
    keys.map((key) => {
      arr = arr.concat(messagesCache[key].artList);
    });
    _.pullAll(messageListCopy, arr);
    state.weakRemindList = messageListCopy;
  },
};

const actions = {
  // 初始化显示哪些菜单
  initTab({ state, commit }) {
    // 公众号引导部分
    const official_status = getStorage('official_status');
    if (official_status != 0) {
      commit('SET_TAB', { action: 'show', val: 'officialWechat' });
    }

    const tel_status = getStorage('tel_status');
    if (tel_status == 0) {
      commit('SET_TAB_HINT', {
        tabType: 'geren',
        hintType: true,
      });
    }

    // 红包活动或盒子游戏(盒子游戏礼包单独处理)显示福利页面
    const activity_status = getStorage('activity_status');
    const boxStatus = getStorage('box_status');
    if (activity_status == 1 || boxStatus != 0) {
      commit('SET_TAB', { action: 'show', val: 'welfare' });
    }

    // 根据是否有未领取的红包活动红包缓存判断啊福利是否显示红点
    const welfareTabHint = getStorage('welfareTabHint');
    if (welfareTabHint) commit('SET_TAB_HINT', { tabType: 'welfare', hintType: true });
  },
  // 请求接口获取强提醒、弱提醒信息
  async getRemind({ state, commit }) {
    const appkey = getStorage('appkey');
    const r = await remindApi({ appkey: appkey });
    const { remind, remind_article_id, message_article_list } = r.content;
    const remindArticleList = getStorage('remind_article_list') || {};
    const userId = getStorage('user_id');
    const cacheList = remindArticleList[userId] || [];
    commit('SET_WEAK_REMIND', message_article_list);
    commit('CHANGE_STATE', {
      remind: {
        ...r.content,
        remind: cacheList.includes(remind_article_id) ? 0 : remind,
      },
    });
  },
  // 请求情报列表
  async getMessagesList({ state, commit }) {
    const appkey = getStorage('appkey');
    const r = await raidersApi({ appkey: appkey, type: 2 });
    // 处理情报列表信息
    const messagesList = r.content.menu_list;
    // article_list为菜单列表下第一个菜单的文章列表
    if (messagesList.length) {
      commit('SET_TAB', { action: 'show', val: 'messages' });
    }
    commit('SET_MESSAGES_REMIND', messagesList);
  },
  // 请求攻略列表
  async getRaidersList({ state, commit }) {
    const appkey = getStorage('appkey');
    const r = await raidersApi({ appkey: appkey, type: 1 });
    const raidersList = r.content.menu_list;
    // article_list为菜单列表下第一个菜单的文章列表
    if (raidersList.length) {
      commit('SET_TAB', { action: 'show', val: 'raiders' });
    }
    commit('CHANGE_STATE', { raidersList: raidersList });
  },
  // 获得首页数据
  async getHomeData({ commit, dispatch }) {
    const appkey = getStorage('appkey');
    const user_id = getStorage('user_id');
    const r = await homeApi({ appkey, user_id });
    const { benefit_list, banner_list, article_list, account_name, account_id, jump_mode, cloud_hang_up } = r.content;
    commit('CHANGE_STATE', {
      benefit_list,
      banner_list,
      article_list,
      account_name,
      account_id,
      jump_mode,
    });
    if (benefit_list && benefit_list.length) commit('SET_TAB', { action: 'show', val: 'welfare' });
    const is_use_ks_sdk = localStorage.getItem('is_use_ks_sdk') === 'true';
    if (banner_list && banner_list.length && !is_use_ks_sdk) commit('SET_TAB', { action: 'show', val: 'home' });
  },
  // 获得新游推荐数据
  async getNewGameData({ commit }) {
    const appkey = getStorage('appkey');
    const r = await newGameList({ appkey: appkey });
    commit('CHANGE_STATE', { newGameList: r.content });
    if (r.content && r.content.length) {
      commit('SET_TAB', { action: 'show', val: 'newGame' });
    }
  },
  // 获取悬浮窗礼包列表
  async getGiftData({ commit, state }) {
    const { role } = state;
    const appkey = getStorage('appkey');
    const user_id = getStorage('user_id');
    const access_token = getStorage('access_token');
    const r = await giftApi({ appkey, user_id, access_token, role_id: role.role_id });
    commit('CHANGE_STATE', { normal_gift: r.content.normal_gift, game_gift: r.content.game_gift });
    if (r.content.normal_gift.length || r.content.game_gift.length) {
      commit('SET_TAB', { action: 'show', val: 'welfare' });
    }
  },
  // 获取绑定手机礼包信息
  async getGiftInfo({ commit }) {
    const appkey = getStorage('appkey');
    const giftList = await giftDetail({ appkey });
    const bindGift = giftList.content.find((item) => item.type == '1');
    commit('CHANGE_STATE', { bindGift });
    return bindGift;
  },
  // 获取个人中心banner信息
  async getPersonalBanner({ commit, state }) {
    const appkey = getStorage('appkey');
    const user_id = getStorage('user_id');
    const { role } = state;
    const r = await getBoxBanner({
      appkey,
      user_id,
      level: role.level || '',
      role_id: role.role_id || '',
    });
    commit('CHANGE_STATE', {
      personalAdSeat: r.content.ad_seat,
      personalAdBanner: r.content.ad_banner.map((item) => {
        return {
          ...item,
          url: item.banner,
        };
      }),
    });
  },
  // 获得当前用户的云挂机设备列表
  async getCloudDeviceList({ commit, state }) {
    const appkey = getStorage('appkey');
    const user_id = getStorage('user_id');
    const r = await cloudDeviceApi({ user_id, appkey });
    const device_list = r.content.device_list.map((item, index) => {
      return {
        ...item,
        picture: '',
        index
      }
    })
    commit('CHANGE_STATE', { cloudDeviceList: device_list });
    tencentCloudSetDevices({
      devices: device_list
    });
    return device_list
  },
  async getProductList({ commit, state, dispatch }) {
    const appkey = getStorage('appkey');
    const user_id = getStorage('user_id');
    const r = await cloudProductApi({ appkey, user_id });
    commit('CHANGE_STATE', { cloudProductList: r.content.product_list });
    if (r.content.cloud_hang_up == 1) {
      commit('SET_TAB', { action: 'show', val: 'hangup' });
      commit('CHANGE_STATE', {
        cloud_hang_up_image: r.content.cloud_hang_up_image,
        cloud_hang_up_box_url: r.content.cloud_hang_up_box_url,
        cloud_hang_up_template_id: r.content.cloud_hang_up_template_id,
        cloud_hang_up_template_name: r.content.cloud_hang_up_template_name,
      });
      dispatch("getCloudDeviceList")
      buryReportV2('CLOUD_HANG_UP_ICON_SHOW', {});
    }
  },
  async getVoucherList({ commit }) { 
    const user_id = getStorage('user_id');
    const appkey = getStorage('appkey');
    const game_version = getStorage('game_version');
    const access_token = getStorage('access_token');

    const r = await voucherApi({ user_id, appkey, game_version, access_token });
    commit('CHANGE_STATE', {
      voucherList: r.content || []
    })
    return r.content || []
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
